export const getContent = (state: any) => state?.data?.content;
export const getSellTransactions = (state: any) => state?.data?.sellTransactions;
export const getTransactionLoading = (state: any) =>
  state?.data?.tranasctionLoading;
